import Api from './api';

const RHService = {
    listarConcursos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/concurso/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarConcurso: (id) => {
        Api.delete(`/restrito/concurso/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    concursoEdit: async (id) => {
        const response = await Api.get(`/restrito/concurso/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarConcurso: async (id, params) => {
        const response = await Api.put(`/restrito/concurso/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarConcurso: (params) => {
        const response = Api.get(`/restrito/concurso/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroConcurso: async (params) => {
        const response = await Api.post('/restrito/concurso/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarEstagiarios: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/estagiario/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarEstagiario: (id) => {
        Api.delete(`/restrito/estagiario/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    estagiarioEdit: async (id) => {
        const response = await Api.get(`/restrito/estagiario/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarEstagiario: async (id, params) => {
        const response = await Api.put(`/restrito/estagiario/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarEstagiario: (params) => {
        const response = Api.get(`/restrito/estagiario/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroEstagiario: async (params) => {
        const response = await Api.post('/restrito/estagiario/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarTerceirizados: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/terceirizado/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarTerceirizados: (id) => {
        Api.delete(`/restrito/terceirizado/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    terceirizadosEdit: async (id) => {
        const response = await Api.get(`/restrito/terceirizado/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarTerceirizados: async (id, params) => {
        const response = await Api.put(`/restrito/terceirizado/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarTerceirizados: (params) => {
        const response = Api.get(`/restrito/terceirizado/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroTerceirizados: async (params) => {
        const response = await Api.post('/restrito/terceirizado/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    }
}

export default RHService;